import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  skeleton: { width: '100%', margin: '22px 0px' }
}))

export default useStyles
